
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regions",
      function () {
        return require("private-next-pages/regions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regions"])
      });
    }
  